import api from './index';
export const getStructureOverview = async () => {
    const res = await api.get('/admin/structure');
    return res.data;
};
export const copyRallyToAccount = async (rallyId, body) => {
    const res = await api.post(`/admin/rallies/${rallyId}/copy-to-account`, body);
    return res.data;
};
export const transferRally = async (rallyId, body) => {
    const res = await api.post(`/admin/rallies/${rallyId}/transfer`, body);
    return res.data;
};
